import { render, staticRenderFns } from "./ContratoPermissaoTerceiros.vue?vue&type=template&id=1511a294&scoped=true"
import script from "./ContratoPermissaoTerceiros.vue?vue&type=script&lang=js"
export * from "./ContratoPermissaoTerceiros.vue?vue&type=script&lang=js"
import style0 from "./ContratoPermissaoTerceiros.vue?vue&type=style&index=0&id=1511a294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511a294",
  null
  
)

export default component.exports